import { useLazyGetSitesQuery } from '@/store/api/diagnosticApi';
import { t } from 'i18next';
import React, { useEffect } from 'react';
import { useToast } from '@/hooks';

export const useFetchSites = () => {
  const [fetchSites, { isLoading, isFetching, data: sites, isError }] = useLazyGetSitesQuery();
  const { toast } = useToast();
  const getSitesData = (refreshCache?: boolean) => {
    fetchSites({ refreshCache }, !refreshCache)
      .unwrap()
      .catch((error) => {
        toast({
          variant: 'destructive',
          title: t('general.errors.title'),
          description: t('general.errors.communication'),
        });
        // Sentry.captureException(
        //   error?.data?.message || error?.error || error?.message || error?.originalError || error
        // );
      });
  };
  useEffect(() => {
    getSitesData();
  }, []);

  return { sites, isLoading: isLoading || isFetching, isError, getSitesData };
};
